
import { MacroCurriculum, MesoCurriculum } from '@/services/roadmap/roadmapService';

export interface Belt {
  name: string;
  color: string;
  dbColor: string; // Database color representation
  stripes?: number;
  isStripe?: boolean;
}

export interface BeltTimelineProps {
  data: MacroCurriculum[] | MesoCurriculum[];
  type: 'macro' | 'meso' | 'micro';
}

export const DEFAULT_BELTS: Belt[] = [
  { name: "White", color: "#ffffff", dbColor: "white" },
  { name: "Blue", color: "#3b82f6", dbColor: "blue" },
  { name: "Purple", color: "#9333ea", dbColor: "purple" },
  { name: "Brown", color: "#8b5a2b", dbColor: "brown" },
  { name: "Black", color: "#000000", dbColor: "black" }
];
